<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')"
        >首页</a-breadcrumb-item
      >
      <a-breadcrumb-item>预约挂号</a-breadcrumb-item>
    </a-breadcrumb>

    <a-tabs>
      <a-tab-pane :key="item.key" :tab="item.name" v-for="item in tabs"> </a-tab-pane>
    </a-tabs>

    <!--搜索框-->
    <a-space class="date-select" @click="jumpPage()">
      <a-input-search
        placeholder="搜索科室、医生"
        size="large"
        readOnly
        style="width: 100%"
        class="search-input"
    /></a-space>
    <!--搜索框-->

    <div class="select-box">
      <div class="select-hospital">
        <h3>选择校区</h3>
        <div
          class="hospital-item"
          v-for="(item, index) in hospitalList"
          :key="item.qydm"
          :class="[index == actived ? 'actived' : '']"
          @click="onChangeHospital(index, item)"
        >
          {{ item.yqmc }}
        </div>
      </div>

      <div class="select-department">
        <h3>选择科室</h3>
        <div class="department-content">
          <div
            v-for="(item, index) in department"
            :key="index"
            :class="[
              index == activedDepartment ? 'activedDepartmentStyle' : '',
              'fontstyle',
            ]"
            @click="onChangeDepartment(index, item)"
          >
            {{ item.ghksmc }}
          </div>
        </div>
      </div>

      <div class="select-doctor">
        <h3>选择医生</h3>
        <div class="department-content" v-if="doctorList.length > 0">
          <div>
            <div
              class="list-item"
              :key="index"
              v-for="(item, index) in doctorList"
              @click="onDoctorDetail(item)"
            >
              <template v-if="item.ygxm">
                <img
                  v-if="item.headerImg"
                  :src="item.headerImg"
                  @error="onImgError(index)"
                  alt=""
                />
                <img v-else src="@/assets/img/doc.png" alt="" />
              </template>
              <img v-else src="@/assets/img/ptmz.png" alt="" />
              <div class="list-pro-name">
                <div class="item-name">
                  <span class="item-name-text">{{ item.ygxm || "普通门诊" }}</span>
                  <span class="item-name-job" v-if="item.ygzc">{{ item.ygzc }}</span>
                  <!-- <span class="item-name-tf" v-if="item.sources > 0">有号</span> -->
                </div>
                <div class="item-department-name">
                  {{ item.ghksmc }}
                </div>
                <div class="item-skilled" v-if="item.goodAt">擅长：{{ item.goodAt }}</div>
              </div>
            </div>
          </div>
        </div>
        <a-empty v-else />
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import base from "@/assets/base/base.js";
import { queryHosInfo, queryResourceInfo, queryDepartmentInfo } from "@/api/registration";
export default {
  data() {
    return {
      searchKey: "",
      actived: 0,
      activedDepartment: 0,
      tabs: [{ key: 1, name: "预约挂号" }],
      // hospitalList: [
      //   { campusName: "西溪院区", qydm: "10219" },
      //   { campusName: "华家池院区", qydm: "10366" },
      //   { campusName: "紫金港院区", qydm: "10393" },
      //   { campusName: "玉泉院区", qydm: "10215" },
      // ],
      hospitalList: [],
      department: [],
      doctorList: [],
      campusName: "",
      remindList: [],
    };
  },
  created() {
    this.dateList = base.getSevenYMD(new Date());
    this.getHospitalList();
  },
  beforeDestroy() {
    this.$notification.destroy();
  },
  methods: {
    onImgError(i){
    this.doctorList[i].headerImg=require('@/assets/img/doc.png');
    },
    // 查询挂号科室代码
    async getQueryDepartmentInfo(param) {
      const params = {
        yqdm: param.qydm,
      };
      const { code, data } = await queryDepartmentInfo(params);
      if (code == 200) {
        this.department = data;
        await this.getDoctor(data[0]);
      }
    },
    //查询院区
    async getHospitalList() {
      const params = {
        organizationId: "1001",
      };
      const { code, data } = await queryHosInfo(params);
      if (code == 200) {
        this.hospitalList = data.filter((e) => {
          return (
            e.yqmc.includes("玉泉") ||
            e.yqmc.includes("西溪") ||
            e.yqmc.includes("紫金港") ||
            e.yqmc.includes("华家池")
          );
        });

        this.getQueryDepartmentInfo(this.hospitalList[0]);
      }
    },
    //进入搜索页
    jumpPage() {
      this.$router.push({
        path: "/DDList",
      });
    },

    disabledDate(current) {
      // Can not select days before today and today
      return current && current < dayjs().endOf("day");
    },
    //查询科室医生
    //查询科室号源信息
    async getDoctor(param) {
      const params = {
        mzks: param.ghksdm, //挂号科室编号
        qssj: this.dateList[0], //起始时间
        jssj: this.dateList[this.dateList.length - 1], //结束时间
      };
      const { code, data } = await queryResourceInfo(params);
      if (code == 200) {
        let doctorList = [];
        for (let index = 0; index < data.length; index++) {
          //专家
          if (data[index].ysdm) {
            let isIndex = doctorList.findIndex((e) => e.ysdm == data[index].ysdm);
            if (isIndex == -1) {
              doctorList.push(data[index]);
            }
          } else {
            //普通
            let isIndex = doctorList.findIndex((e) => e.ysdm == data[index].ysdm);
            if (isIndex == -1) {
              doctorList.push(data[index]);
            }
          }
        }
        this.doctorList = doctorList;
      }
    },
    onDoctorDetail(data) {
      const query = {
        ...data,
      };
      this.$router.push({
        path: "/doctorDetail",
        query: { data: JSON.stringify(query) },
      });
    },
    async onChangeHospital(index, data) {
      this.activedDepartment = 0;
      this.actived = index;
      this.campusName = data.yqmc;
      this.qydm = data.qydm;
      await this.getQueryDepartmentInfo(data);
    },
    async onChangeDepartment(index, data) {
      this.activedDepartment = index;
      await this.getDoctor(data);
    },
  },
};
</script>

<style lang="scss" scoped>
.fontstyle {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
}

.container {
  .date-select {
    padding: 20px;
    width: 100%;
    border-radius: 4px;
    background: #f8f8f8;
    .ant-space-item {
      width: 100%;
    }

    .date-label {
      font-size: 16px;
    }

    .date-select-day {
      cursor: pointer;
      background: #ffffff;
      padding: 10px;
      border: 1px solid #3f86ff;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #3f86ff;
    }

    .activedDay {
      color: #fff;
      background-color: #3f86ff;
    }
  }

  .select {
    .title {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      padding-right: 30px;

      h3 {
        font-size: 20px;
      }

      .line {
        width: 100px;
        height: 2px;
        background: #000;
      }
    }
  }

  .select-box {
    display: flex;
    justify-content: center;
    padding: 20px 0;

    h3 {
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #f8f8f8;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
    }

    .select-hospital {
      flex: 3;
      border: 1px solid #f8f8f8;

      .hospital-item {
        cursor: pointer;
        height: 50px;
        box-sizing: border-box;
        font-size: 16px;
        text-align: center;
        line-height: 50px;
      }
    }

    .select-department {
      flex: 5;
      border: 1px solid #f8f8f8;
      padding: 0 16px;
    }

    .department-content {
      height: 500px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .select-doctor {
      flex: 4;
      cursor: pointer;
      box-sizing: border-box;
      font-size: 16px;
      border: 1px solid #f8f8f8;
      margin-left: -1px;

      .list-item {
        display: flex;
        padding: 16px;
        align-items: center;
        border-bottom: 1px solid #f8f8f8;
        cursor: pointer;

        img {
          text-align: center;
          width: 60px;
          height: 60px;
          margin-right: 12px;
          border-radius: 50%;
          border: 1px solid #f8f8f8;
        }

        .list-pro-name {
          margin-left: 12px;
          .item-name {
            margin: 2px 0;
          }

          .item-name {
            font-size: 14px;

            &-text {
              font-size: 18px;
              color: #333;
            }

            &-job {
              color: #333;
              padding: 0 10px;
            }

            &-tf {
              padding: 1px 4px;
              color: #3f86ff;
              border: 1px solid #3f86ff;
              border-radius: 2px;
              margin-right: 4px;
            }
          }

          .item-department-name {
            margin-top: 4px;
            color: #666;
            font-size: 14px;
          }

          .item-skilled {
            margin-top: 4px;
            width: 250px;
            font-size: 14px;
            color: #888;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .actived,
  .activedDepartmentStyle {
    font-weight: bold;
    background-color: rgba(63, 134, 255, 0.07) !important;
  }
  .search-input {
    height: 40px;
    outline: none;
    cursor: pointer;
  }
}
</style>
